import React, { useEffect } from "react";
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/react";
import PictureCard from "./PictureCard";
import { arrowBackCircle } from "ionicons/icons";
import { useLocation } from "react-router";
import { usePictures } from "./usePictures";
import "./PicturePreview.css";

const PicturePreview: React.FC = () => {
  const { selectedPicture, selectPicture } = usePictures();
  const location = useLocation();

  const dismiss = () => {
    selectPicture(undefined);
  };

  useEffect(() => {
    if (selectedPicture) {
      dismiss();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <IonModal
      isOpen={selectedPicture !== undefined}
      onDidDismiss={dismiss}
      showBackdrop={true}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonIcon
              color="primary"
              className="f36"
              icon={arrowBackCircle}
              onClick={dismiss}
              style={{ paddingLeft: "5px" }}
            />
          </IonButtons>
          <IonTitle>{selectedPicture?.title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <div style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
        <PictureCard pic={selectedPicture} isPopup={true} />
        {/* <div style={{ padding: "20px" }}>&nbsp;</div> */}
      </div>
    </IonModal>
  );
};

export default PicturePreview;
